import React, { useEffect, createContext, useContext, useReducer, Dispatch } from 'react';

import { IActionParams } from 'stores/StoreInterface/action';
import { useStateReducer, IUseStateReducer } from 'stores/StoreInterface/reducer';
import { useApiRequest } from 'hooks';
import { ServiceState, ServiceAction } from 'stores/ServiceStore';
import { ServiceSmallMoveState, ServiceSmallMoveAction } from 'stores/ServiceSmallMoveStore';
import { apiGetTempData } from 'api/ZimssaAPI';

export interface ISmallMoveServiceCarState {
    size: string;
    type: string;
    etc: string;
    plateNumber: string;
    color: string;
    image: string;
}

export const defaultState: ISmallMoveServiceCarState = {
    size: '',
    type: '',
    etc: '',
    plateNumber: '',
    color: '',
    image: '',
};

export const CarInfoState = createContext<ISmallMoveServiceCarState>(defaultState);
export const CarInfoAction = createContext<Dispatch<IActionParams<ISmallMoveServiceCarState>>>(() => {});

interface Props {
    children: React.ReactElement;
}

function StoreProvider({ children }: Props) {
    const [states, dispatcher] = useReducer<IUseStateReducer<ISmallMoveServiceCarState>>(useStateReducer, defaultState);

    const serviceDispatcher = useContext(ServiceAction);
    const smallMoveDispatcher = useContext(ServiceSmallMoveAction);
    const { serviceValid } = useContext(ServiceState);
    const { smallMoveValid } = useContext(ServiceSmallMoveState);
    const [fetchGetTempDataResult, fetchGetTempDataSet] = useApiRequest<any>(apiGetTempData);

    useEffect(() => {
        const { result, data } = fetchGetTempDataResult;

        if (result === 'success' && data) {
            serviceDispatcher({
                type: 'SET_STATE',
                value: {
                    serviceImage: data.service.serviceImage,
                    serviceName: data.service.serviceName,
                    introduce: data.service.introduce,
                    location1: data.service.location1,
                    location2: data.service.location2,
                    startYear: data.service.startYear,
                    businessRegistrationNumber: data.service.businessRegistrationNumber,
                    taxClassification: data.service.taxClassification,
                    businessRegistrationImage: data.service.businessRegistrationImage,
                    businessRegistrationOwner: data.service.businessRegistrationOwner,
                    familyRelationImage: data.service.familyRelationImage,
                },
            });

            smallMoveDispatcher({
                type: 'SET_STATE',
                value: {
                    transportationLicenseNumber: data.smallMove.transportationLicenseNumber,
                    transportationLicenseImage: data.smallMove.transportationLicenseImage,
                },
            });
        }
    }, [fetchGetTempDataResult, serviceDispatcher, smallMoveDispatcher]);

    useEffect(() => {
        if (!serviceValid && !smallMoveValid) {
            fetchGetTempDataSet({
                type: 'REQUEST',
                body: ['smallmove'],
            });
        }
    }, [fetchGetTempDataSet, serviceValid, smallMoveValid]);

    return (
        <CarInfoAction.Provider value={dispatcher}>
            <CarInfoState.Provider value={states}>{children}</CarInfoState.Provider>
        </CarInfoAction.Provider>
    );
}

export default StoreProvider;
